import type { ReactPerformance } from "@/lib/react_performance"
import { isManagedState } from "@/lib/react_performance/isManagedState"

export const hasManagedState = <Props, State>(
  component: unknown
): component is ReactPerformance.ComponentWithManagedState<
  Props,
  ReactPerformance.Managed<State>
> => {
  return (
    Boolean(component) &&
    typeof component === `object` &&
    isManagedState((component as unknown as Record<string, unknown>).state) &&
    typeof (component as unknown as Record<string, unknown>).updateState ===
      `function`
  )
}
